<template>
  <v-container grid-list-md fluid class="pa-0">
    <!--<v-card class="pa-2 card-r mb-2">-->
    <v-toolbar class="mb-2 tow-clor-1 card-r shadow-1 pl-3 text-white">
      <div class="text-xs-left f-17">Subscription</div>
    </v-toolbar>
      <v-layout>
        <v-flex>
          <v-data-table :headers="headers" :items="SubscriptionData" class=" card-r no-shadow">
            <template slot="items" slot-scope="props">
              <!-- <td>11</td> -->
              <td class="text-xs-right">{{ props.item.startDate }}</td>
              <td class="text-xs-right">{{ props.item.endDate }}</td>
              <td class="text-xs-right">{{ props.item.amount }}</td>
              <td class="text-xs-right">{{ props.item.dkk }}</td>
              <td class="text-xs-right">
                <v-dialog
                  v-model="dialog"
                  width="500">
                  <v-icon slot="activator">visibility</v-icon>
                  <v-card  class="pa-4">
                    <v-layout xs12>
                      <v-flex xs12 class="text-lg-center">
                        <h1 class="pb-4">
                          Invoice
                        </h1>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex  xs12 class="mt-3 mb-3">
                        <img class="invoice-logo " src="https://wallpaperaccess.com/full/128916.jpg" alt="logo">
                      </v-flex>
                      <v-flex xs12 class="mt-3">
              <span>
              <strong>Ms. Rani Rabukpotha,	 </strong><br>
              Kuliyapitiya Road,	P. O. Box No. 875,
              PANNALA (NWP) 60160
              </span>
                      </v-flex>
                    </v-layout>
                    <v-divider ></v-divider>
                    <v-layout xs12 class="layout-invoice-contant">
                      <v-flex xs6 class="mt-3">
                        <span >Customer Name: <code> NAME</code></span><br><br>
                        <span >Subscription Number: <code> 1234</code></span><br><br>
                        <span >Validity Period: <code> DD/MM/YYYY</code> to <code>DD/MM/YYYY</code></span>
                      </v-flex>
                      <v-flex xs6 justify-center class="mt-3">
                        <v-flex xs6 justify-center class="mt-3">
                          <span>Amount Paid</span>
                        </v-flex>
                        <v-flex xs6 justify-center class="mt-3">
                          <span class="span">$15000</span>
                        </v-flex>
                      </v-flex>
                    </v-layout>

                  </v-card>
                </v-dialog>
              </td>
            </template>
          </v-data-table>
        </v-flex>

      </v-layout>
    </v-container>
</template>
<script>
  /* eslint-disable */
  export default {
    name:"Subscription",
    data:()=>({
      dialog:false,
      headers: [
        // {
        //   text: "#",
        //   value: "Number"
        // },
        {
          text: "Start Date",
          value: "startDate"
        },
        { text: "End Date", value: "endDate" },
        { text: "Amount", value: "amount" },
        { text: "DKK", value: "dkk" },
        // { text: "EMAIL", value: "email" },
        // { text: "GENDER", value: "gender" },
        // { text: "STATUS", value: "status" },
        // { text: "CHANGE TEACHER", value: "changeTeacher" }
      ],
      SubscriptionData:[
        {
          startDate:'22.2.2018',
          endDate:'22.2.2018',
          amount:'555',
          dkk:'dkk',

        }
      ]
    })
  }
</script>
<style>
  .invoice{
    width: 700px;

  }
  .invoice-logo{
    margin: auto;
    border: 3px solid white;
    width: 150px !important;
    height: 150px;
    border-radius: 50%;
    -webkit-box-shadow: 10px 10px 14px -2px rgba(173,173,173,1);
    -moz-box-shadow: 10px 10px 14px -2px rgba(173,173,173,1);
    box-shadow: 10px 10px 14px -2px rgba(173,173,173,1);
    background-color: transparent !important;
  }
  .layout-invoice-contant{
    font-size: 12px;
    font-weight: 600;
  }
  .layout-invoice-contant span{
    padding: 10px 0px 10px 0px;

  }
  .layout-invoice-contant .span{
    border: 1px solid #0097cf;
    padding-left: 25px;
    padding-right: 25px;

  }
  .invoice .v-dialog:not(.v-dialog--fullscreen){
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/components/profile/student/StudentInvoice.vue